import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_WORK_ORDER_TEMPLATES: createSagaAction('GET_WORK_ORDER_TEMPLATES'),
  GET_WORK_ORDER_TEMPLATE_ITEMS: createSagaAction('GET_WORK_ORDER_TEMPLATE_ITEMS')
}

// Action Creators
export const actions = {
  getWorkOrderTemplates: () => ({
    type: constants.GET_WORK_ORDER_TEMPLATES.ACTION
  }),

  getWorkOrderTemplateItems: workOrderId => ({
    type: constants.GET_WORK_ORDER_TEMPLATE_ITEMS.ACTION,
    workOrderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_WORK_ORDER_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_WORK_ORDER_TEMPLATES.SUCCESS:
      return {
        ...state,
        workOrderTemplates: action.payload
      }
    case constants.GET_WORK_ORDER_TEMPLATE_ITEMS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_WORK_ORDER_TEMPLATE_ITEMS.SUCCESS:
      return {
        ...state,
        workOrderTemplateItems: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/workOrderTemplatesActions.js